import { NewselaFullSVG, NewselaMarkSVG } from "@newsela/angelou";

import Icon from "@/components/Icon";
import { logoFullCss, logoMarkCss } from "./NewselaLogo.style";

const NewselaLogo = () => (
  <>
    <Icon SvgComponent={NewselaMarkSVG} css={logoMarkCss} />
    <Icon SvgComponent={NewselaFullSVG} css={logoFullCss} />
  </>
);

export default NewselaLogo;
